import React from 'react';

export default function ProgressBar({
  as: Element = 'div',
  decorative = false,
  label,
  value,
  variant = 'xp',
}) {
  const safeValue = Math.min(100, Math.max(0, Number(value) || 0));
  const accessibilityProps = decorative
    ? { 'aria-hidden': true }
    : {
      'aria-label': label,
      'aria-valuemax': '100',
      'aria-valuemin': '0',
      'aria-valuenow': Math.round(safeValue),
      role: 'progressbar',
    };

  return (
    <Element
      className={`pl-progress pl-progress--${variant}`}
      {...accessibilityProps}
    >
      <span className="pl-progress__fill" style={{ '--pl-progress': `${safeValue}%` }} />
    </Element>
  );
}
